import queryString from "query-string";
import {
  DeleteParams,
  GetListParams,
  TenantUserRepositoryInterface,
} from "./tenantUser.repository.d";
import { BaseRepository } from "../Base/base.repository";
import { GetTenantUserDto } from "./dto/get.dto";
import { CreateTenantUserDto } from "./dto/create.dto";
import { ServerlessConfigure } from "../../config/serverless-configure";
import { UpdateTenantUserDto } from "./dto/update.dto";

export class TenantUserRepository
  extends BaseRepository<GetTenantUserDto>
  implements TenantUserRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: ServerlessConfigure.ApiEndpoint,
      },
      {
        hasSendToken: true,
      },
    );
  }

  async getList(params: GetListParams) {
    const response = await this.apiRequest.getList({
      url: `/users?${queryString.stringify(params)}`,
    });

    return response.data.Items;
  }

  async create({
    userFirstName,
    userLastName,
    userEmail,
    userRole,
  }: CreateTenantUserDto) {
    const response = await this.apiRequest.post<GetTenantUserDto>({
      url: "/users",
      data: {
        userFirstName,
        userLastName,
        userEmail,
        userRole,
      },
    });

    return response;
  }

  delete({ id }: DeleteParams) {
    return this.apiRequest.delete({
      url: `/users/${id}`,
    });
  }

  async update({
    id,
    userFirstName,
    userLastName,
    userRole,
    isActive,
  }: UpdateTenantUserDto) {
    const response = await this.apiRequest.put<GetTenantUserDto>({
      url: `/users/${id}`,
      data: {
        userFirstName,
        userLastName,
        userRole,
        isActive,
      },
    });

    return response;
  }
}
